import { SVGProps, Ref, forwardRef } from 'react';

export const QuestionFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.4 8.143c0-1.136.365-2.066.954-2.7C9.933 4.822 10.804 4.4 12 4.4c1.212 0 2.081.409 2.652 1.014.579.615.948 1.538.948 2.729 0 1.6-.8 2.373-1.988 3.407l-.135.118c-1.144.991-2.677 2.32-2.677 4.832h2.4c0-1.388.742-2.055 1.988-3.14C16.4 12.305 18 10.9 18 8.143c0-1.689-.53-3.237-1.602-4.374C15.32 2.623 13.789 2 12 2c-1.804 0-3.332.657-4.404 1.81C6.536 4.95 6 6.493 6 8.143z"
                fill="currentColor"
            />
            <path d="M13.725 20.275a1.725 1.725 0 1 0-3.45 0 1.725 1.725 0 0 0 3.45 0" fill="currentColor" />
        </g>
    </svg>
));
QuestionFilledSize24Glyph.displayName = 'QuestionFilledSize24Glyph';
